import React from 'react'
import loader from '../assets/image/placeholder.gif'
import Background from './Background'
const Loader = () => {
  return (
    <div>
        <div className='w-screen h-screen relative flex z-50 items-center justify-center'>
        <div id="loader"  className='scale-[2]'>
    <div className="ls-particles ls-part-1"></div>
    <div className="ls-particles ls-part-2"></div>
    <div className="ls-particles ls-part-3"></div>
    <div className="ls-particles ls-part-4"></div>
    <div className="ls-particles ls-part-5"></div>
    <div className="lightsaber ls-left ls-green"></div>
    <div className="lightsaber ls-right ls-red"></div>
  </div>
  <div className='animate-pulse text-slate-300 font-extrabold mt-36 newfont'>LOADING</div>


           
        </div>
        <Background/>
    </div>
  )
}

export default Loader
